export default "__VITE_ASSET__Du7Qi39J__"